import { render } from "./dotCanvas.vue?vue&type=template&id=91a7a4e8&scoped=true"
import script from "./dotCanvas.vue?vue&type=script&lang=js"
export * from "./dotCanvas.vue?vue&type=script&lang=js"

import "./dotCanvas.vue?vue&type=style&index=0&id=91a7a4e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91a7a4e8"]])

export default __exports__